import { Link } from "react-router-dom";

const categories = [
  {
    title: "日本伦理片",
    desc: "细腻克制的东瀛情感叙事",
    icon: "ri-mac-line",
    to: "/category?region=%E6%97%A5%E6%9C%AC",
  },
  {
    title: "韩国伦理片",
    desc: "张力十足的韩式剧情表达",
    icon: "ri-heart-3-line",
    to: "/category?region=%E9%9F%A9%E5%9B%BD",
  },
  {
    title: "经典作品",
    desc: "经得起时间回味的佳作",
    icon: "ri-award-line",
    to: "/category?sort=rating",
  },
  {
    title: "新片推荐",
    desc: "近期更新的热门作品",
    icon: "ri-flashlight-line",
    to: "/category?sort=updated",
  },
];

export default function CategoryShortcuts() {
  return (
    <section className="mx-auto w-full max-w-[1400px] px-4 py-10 md:px-8 md:py-14">
      <div className="mb-6 flex items-end justify-between">
        <div>
          <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
            分类快捷入口
          </h2>
          <p className="mt-1 text-sm text-foreground-600">
            按地区、口碑与更新节奏，快速找到你想看的故事
          </p>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-3 md:gap-5 lg:grid-cols-4">
        {categories.map((cat) => (
          <Link
            key={cat.title}
            to={cat.to}
            className="group flex flex-col gap-3 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 hover:bg-background-100 md:p-5"
          >
            <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-primary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
              <i className={`${cat.icon} text-xl`} />
            </span>
            <div>
              <h3 className="font-heading text-base font-semibold text-foreground-950">
                {cat.title}
              </h3>
              <p className="mt-1 text-xs leading-relaxed text-foreground-600 md:text-sm">
                {cat.desc}
              </p>
            </div>
            <span className="mt-auto inline-flex items-center gap-1 text-xs font-medium text-primary-700">
              进入分类
              <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}